<template>
  <div>
    <v-card  class="pa-0 ma-0" v-if="listOfComments.length > 0" flat>
        <template v-for="(comment, index) in listOfComments">
          <div :key="index">
            <v-card class="mb-3">
            <v-row class="ma-0">
              <v-col cols="12" lg="2" class="pa-0 pl-2 pt-2">
              <v-avatar color="primary" class="pa-0" size="36">
                <span class="mx-auto white--text">
                  <strong>{{ comment.user_lastname ? `${comment.user_firstname.charAt(0).toUpperCase()}${comment.user_lastname.charAt(0).toUpperCase()}`  : comment.user_firstname.charAt(0).toUpperCase() }}</strong>
                </span>
              </v-avatar>
              </v-col>
               <v-col cols="12" lg="5" class="pa-0 ma-0 pt-2">
                <span class="font-weight-medium"> {{comment.user_firstname}} {{comment.user_lastname}} </span>
                <p class="font-weight-regular my-0"> {{ $formatter.formatDate(comment.updated_on, 'DD.MM.YYYYTHH:mm:ss', 'DD.MM.YYYY HH:mm') }} </p>
              </v-col>
              <v-col cols="12" lg="12" class="pa-0">
              <v-divider></v-divider>
              </v-col>
              <v-col cols="12" lg="12" class="pa-0 pl-2 pt-1">
                <v-hover v-slot:default="{ hover }">
                  <v-row v-if="!comment.showEdit" class="mx-0">
                    <v-col cols="12" lg="10" class="pa-1">
                      <p v-html="comment.comment"></p>
                    </v-col>
                    <v-col cols="12" lg="2" v-if="hover && !isView" @click="showEditHandler(index)" class="pa-1">
                      <v-icon v-if="userId === comment.updated_by" small>mdi-pencil</v-icon>
                    </v-col>
                  </v-row>
                  <v-row v-else class="mx-0">
                    <v-col cols="12" lg="12" class="py-0 px-1">
                      <div id="app-editor-comments">
                        <ckeditor :editor="editor" :config="configuration" v-model="comment.comment" id="app-comments-section" :key="reRender"></ckeditor>
                      </div>
                      <v-flex class="text-right">
                      <v-btn-toggle v-model="toggle_exclusive">
                        <v-btn small @click="updateComments(index)">
                          <v-icon>mdi-check</v-icon>
                        </v-btn>
                        <v-btn small @click="listOfComments[index].showEdit = false">
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </v-btn-toggle>
                      </v-flex>
                     </v-col>
                  </v-row>
                </v-hover>
              </v-col>
            </v-row>
          </v-card>
          </div>
        </template>
    </v-card>
    <v-alert prominent text v-else type="info" class="mt-2" >
      <v-row align="center">
        <v-col class="grow">{{ $t('message.common.noComments') }}</v-col>
      </v-row>
    </v-alert>
    <div class="pt-3">
      <div v-if="showCommentBox" class="commentBox  font-weight-regular text--primary">
        <ckeditor :editor="editor" :config="configuration" v-model="modelObj.comment"></ckeditor>
          <v-flex class="text-right">
            <v-btn-toggle v-model="toggle_exclusive" class="justify-right">
              <v-btn small @click="saveComments()">
                <v-icon>mdi-check</v-icon>
              </v-btn>
              <v-btn small @click="showCommentBox = false, modelObj.comment = ''">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-btn-toggle>
        </v-flex>
      </div>
      <v-btn block color="primary" v-else-if="!isView" outlined @click="showCommentBox = true">{{$t('message.tickets.addComments') }}</v-btn>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import { mapGetters, mapState } from 'vuex'
import Editor from '@/ckeditor'
export default {
  props: ['ticketNumber', 'assignedto', 'listOfComments', 'isView'],
  data () {
    return {
      ticketId: this.$route.params.ticket_id,
      editor: Editor,
      toggle_exclusive: 2,
      showCommentBox: false,
      userId: this.$store.state.userDetails.id,
      modelObj: {
        ticket_id: this.$route.params.ticket_id,
        comment: ''
      },
      configuration: {
        height: '250px',
        sharedSpaces: {
          top: 'toolbarLocation'
        },
        toolbar: {
          items: [ 'bold', 'italic', 'outdent', 'indent', '|', 'bulletedList', 'numberedList', '|', 'insertTable', 'blockQuote', 'undo', 'redo']
        },
        mention: {},
      },
      getUsers: [],
      reRender: 0
    }
  },
  computed: {
    ...mapState(['listOfUsers', 'listOfGroups'])
  },
  mounted () {
    let users = this.$formatter.cloneVariable(this.listOfUsers)
    users.forEach(element => {
      let  id = element.id
      element.userId = id
      element.id = `@${element.fullname}`
      element.link = 'https://ckeditor.com/docs/ckeditor5/latest/examples/framework/chat-with-mentions.html'
    })
    this.getUsers = users
    this.configuration.mention = {
      feeds: [{
        marker: '@',
        feed: this.getUsers,
        itemRenderer: this.customItemRenderer,
        minChars: 0
      }]
    }
    this.$forceUpdate()
  },
  methods: {
    customItemRenderer( item ) {
      const itemElement = document.createElement( 'span' )
      itemElement.classList.add( 'custom-item' )
      itemElement.id = `mention-list-item-id-${ item.userId }`
      itemElement.textContent = `${ item.fullname } `
      return itemElement
    },
    showEditHandler(index) {
      let item = this.$formatter.cloneVariable(this.listOfComments[index])
      item.showEdit = true
      this.$set(this.listOfComments, index, item)
    },
    saveComments () {
      let mentionedIds = []
      let elements = document.querySelectorAll('.commentBox .mention')
      elements.forEach(element => {
        let id = element.attributes[2].value
        mentionedIds.push(parseInt(id))
      })
      let model = this.$formatter.cloneVariable(this.modelObj)
      this.$_executeApi('post', 'ticketcomments', model).then(response => {
        if (mentionedIds.length > 0) {
          let  msg = `You are mentioned in ${this.ticketNumber} by ${this.$store.state.userDetails.name}`
          this.$eventBus.$emit('SendNotification', mentionedIds, msg, this.ticketId)
        }
        if (this.assignedto) {
          let assignedTo = this.$formatter.cloneVariable(this.assignedto)
          assignedTo = assignedTo.split('_')
          if (assignedTo[0] === 'group') {
            // let item = this.listOfGroups.find(x => x.id == assignedTo[1])
            // let usersarray = []
            // let query = { filter: `groupid eq ${assignedTo[1]} and isactive eq 1` }
            // let  msg = `${this.$store.state.userDetails.name} added comments in ${this.ticketNumber}`
            //   this.$_executeApi('get', `usergroups/get_by_group/${assignedTo[1]}`).then(result => {
            //   usersarray = result.data.map(x => x.user_id)
            // }).finally(() => {
            //   this.getsignalRConnection.invoke('SendNotification', usersarray, msg, this.ticketId)
            // })
          } else {
            if (this.$store.state.userDetails.id != assignedTo[1]) {
              let msg = `${this.$store.state.userDetails.name} added comments in ${this.ticketNumber}`
              this.$eventBus.$emit('SendNotification', [assignedTo[1]], msg, this.ticketId)
            }
          }
        }
        this.$root.$emit('loadComments', this.ticketId)
        this.modelObj.comment = ''
        this.showCommentBox = false
      })
    },
    updateComments (index) {
      let model = this.$formatter.cloneVariable(this.listOfComments[index])
      this.$_executeApi('put', `ticketcomments/${model.id}`, model).then(response => {
        this.$root.$emit('loadComments', this.ticketId)
        this.listOfComments[index].showEdit = false
      })
    },
    addCommentsHandler () {
      this.showCommentBox = true
      this.autoFocusOnField()
    },
    autoFocusOnField () {
      setTimeout(() => {
        var div = document.getElementsByClassName('ck-editor__editable_inline')
        if (div && div[div.length - 1]) div[div.length - 1].focus()
      }, 100)
    }
  }
}
</script>
<style>
.custom-item  {
  display: block;
}
</style>
